
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import includes from 'lodash/includes';

import { Log } from '../../../core';
const log = Log.getLogger('MultiSceneForApp.layer.LegendPanel');

const LayerItemLegend = (props) => {

    const classNames = mergeStyleSets({
        root: {
            paddingTop: 4
        },
        image: {
            width: 40,
            height: 20
        },
        row: {
            paddingTop: 2,
            paddingBottom: 2
        },
        text: {

        },
        title: {
            paddingTop: 4,
            fontWeight: 'bold'
        }
    });

    return (
        <Stack className={classNames.root}>
            {props.legend.title && <Stack.Item className={classNames.title}>{props.legend.title}</Stack.Item>}
            {props.legend.items.map((item, index) => {
                let imageElement = <div className={classNames.image}></div>;
                if (item.color) {
                    imageElement = <div className={classNames.image} style={{backgroundColor: item.color}}></div>;
                }
                if (item.image) {
                    imageElement = <img className={classNames.image} src={item.image} />
                }

                return (
                    <Stack horizontal gap={8} key={index} className={classNames.row}>
                        <Stack.Item>{imageElement}</Stack.Item>
                        <Stack.Item className={classNames.text}>{item.title}</Stack.Item>
                    </Stack>
                );
            })}
        </Stack>
    );
}

const LegendPanel = (props) => {

    const classNames = mergeStyleSets({
        root: {
        }
    });

    const getLayerDef = (layerId) => {
        return props.mapLayersDefs.reduce((previous, actual) => {
            return (actual.id === layerId)
                ? actual
                : previous;
        }, null);
    }

    const getLegendItems = () => {
        let legendItems = [];
        props.layers.forEach(virtualLayer => {
            if(virtualLayer.visible) {
                virtualLayer.layers.forEach(layer => {
                    let layerDef = getLayerDef(layer);
                    if (layerDef.legend) {
                        const legendItemWithId = legendItems.reduce(
                            (previous, current) => {
                                return (current.id === layerDef.legend.id)
                                    ? current
                                    : previous;
                            }, null
                        );
                        if (legendItemWithId) {
                            legendItemWithId.items = [
                                ...legendItemWithId.items,
                                ...layerDef.legend.items
                            ];
                        } else {
                            legendItems.push({
                                id: layerDef.legend.id,
                                title: layerDef.legend.title,
                                items: [
                                    ...layerDef.legend.items
                                ]
                            });
                        }
                    }
                });
            }
        });
        return legendItems
    }

    return (
        <Stack className={classNames.root}>
            {getLegendItems().map(item => {
                return (
                    <LayerItemLegend
                        key={item.id}
                        legend={item}
                    />
                );
            })}
        </Stack>
    );
};

export default LegendPanel;
